<!--
 * @message: 图片查看灯箱
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-21 17:20:20
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_LightBox.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-03 14:24:08
-->
<template>
  <v-dialog
    v-model="show"
    :width="600"
    :hide-overlay="true"
    :no-click-animation="true"
    :persistent="true"
  >
    <v-card>
      <v-toolbar :color="`${color} balck--text`" flat dense class="pr-3">
        <v-toolbar-title class="text-subtitle-2">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click.stop="closeDialog"
              color="grey"
              x-small
            >
              <span class="material-icons-round"> close </span>
            </v-btn>
          </template>
          <span>关闭</span>
        </v-tooltip>
      </v-toolbar>
      <v-hover v-slot:default="{ hover }">
        <v-card-text class="grey lighten-5 pa-3">
          <v-btn
            icon
            class="grey lighten-1"
            color="white"
            v-if="hover && imageList.length > 1 && curIndex != 0"
            @click="onClick(-1)"
            style="position: absolute; margin-top: 50%; left: 10px; z-index: 9"
          >
            <i class="material-icons-round">keyboard_arrow_left</i>
          </v-btn>
          <v-btn
            icon
            color="white"
            class="grey lighten-1"
            @click="onClick(1)"
            v-if="
              hover && imageList.length > 1 && curIndex != imageList.length - 1
            "
            style="position: absolute; margin-top: 50%; right: 10px; z-index: 9"
          >
            <i class="material-icons-round">keyboard_arrow_right</i>
          </v-btn>
          <v-img
            :src="curImage['imageUrl']"
            transition="slide-x-transition"
            height="600"
            width="100%"
            contain
          ></v-img>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "LightBox",
  props: {
    show: { default: false, type: Boolean },
    color: { default: "white", type: String },
    index: { default: 0, type: Number },
    imageList: {
      default: [],
      type: [String, Array],
    },
  },
  watch: {
    index(val) {
      this.curIndex = val;
    },
  },
  computed: {
    title() {
      if (this.imageList.length) {
        let url = this.imageList[this.curIndex]["imageUrl"];
        return this.imageList[this.curIndex]["filename"];
      } else {
        return "";
      }
    },
    curImage() {
      return this.imageList[this.curIndex];
    },
  },
  mounted() {},
  data() {
    return { curIndex: 0 };
  },
  methods: {
    onClick: function (ind) {
      this.curIndex = this.curIndex + ind;
    },
    closeDialog: function () {
      this.$emit("close");
    },
  },
};
</script>
